import React from "react";
import {
  FaCheck,
  FaFileAlt,
  FaMobileAlt,
  FaPalette,
  FaPrint,
  FaWhatsapp,
} from "react-icons/fa";
import Footer from "../../components/Footer/footer";
import PNPLogo from "../../assets/PNP_Ranch_logo_black_transparent.png";
import LogoOMG from "../../assets/Facelogo.jpg";
import LogoNapatoisto from "../../assets/Napatoiston logo.webp";
import LogoProGreen from "../../assets/Pro_green_logo.webp";
import LogoEcocreative from "../../assets/ecocreative.webp";
import LogoBuukkeri from "../../assets/buukkeri-logo.webp";
import LogoParanoidi from "../../assets/paranoidi-favicon-512.png";
import { deepMerge, useSiteContent } from "../../content/SiteContentContext";

const WHATSAPP_NUMBER = "358443519265";

const copy = {
  fi: {
    badge: "Räätälöity logosuunnittelu",
    title: "Logon suunnittelu yritykselle, artistille tai brändille",
    lead:
      "Suunnittelen tunnistettavan logon, joka toimii verkossa, somessa ja painotuotteissa. Lopullinen logo viimeistellään huolellisesti vektorimuotoon ja toimitetaan sovituissa tiedostomuodoissa ilman valmista massapohjaa.",
    primaryCta: "Kysy logosta WhatsAppilla",
    secondaryCta: "Ota yhteyttä",
    trust: [
      "Räätälöity suunnittelu",
      "Vektorimuoto",
      "Verkko + some + paino",
      "Palautekierrokset",
    ],
    whoTitle: "Kenelle logosuunnittelu sopii?",
    whoLead:
      "Kun tarvitset oman tunnuksen, joka näyttää uskottavalta eri kanavissa ja kestää käyttöä pitkään.",
    who: [
      "Yritykset ja toiminimet",
      "Artistit ja bändit",
      "Henkilöbrändit",
      "Yhdistykset ja tapahtumat",
      "Uudet palvelut ja projektit",
      "Brändit, joiden vanha logo kaipaa uudistusta",
    ],
    deliverablesTitle: "Mitä logo-projektiin voidaan sisällyttää?",
    deliverables: [
      {
        icon: "palette",
        title: "Omaan brändiin suunniteltu ilme",
        text:
          "Logo suunnitellaan nimen, toimialan, kohderyhmän ja halutun tunnelman ympärille. Tarkoitus ei ole tehdä geneeristä tunnusta vaan juuri sinun käyttöön sopiva ratkaisu.",
      },
      {
        icon: "file",
        title: "Vektoritiedostot ja käyttöversiot",
        text:
          "Toimitukseen voidaan sisällyttää esimerkiksi SVG-, PDF- ja PNG-versiot sekä musta, valkoinen tai muu tarvittava käyttövaihtoehto.",
      },
      {
        icon: "mobile",
        title: "Toimii myös pienessä koossa",
        text:
          "Logo huomioidaan verkkosivulla, somessa, profiilikuvissa ja muissa pienissä käyttökoissa, joissa yksityiskohtien pitää säilyä selkeinä.",
      },
      {
        icon: "print",
        title: "Painokelpoinen toteutus",
        text:
          "Tarvittaessa logo valmistellaan painokäyttöön sopivaksi, jotta sama tunnus toimii esimerkiksi kylteissä, tekstiileissä, tarroissa ja painotuotteissa.",
      },
    ],
    caseEyebrow: "Esimerkkiprojekti",
    caseTitle: "PNP Ranch – valmis logo verkkoon ja painoon",
    caseLead:
      "PNP Ranchille suunniteltiin hevosaiheinen logo asiakkaan toiveiden pohjalta. Tunnusta hiottiin palautteen mukaan, minkä jälkeen lopullinen versio viimeisteltiin Adobe Illustratorissa vektorimuotoon.",
    caseBullets: [
      "Hevosaiheinen tunnus asiakkaan omien toiveiden pohjalta",
      "Lopullinen vektoriviimeistely Adobe Illustratorissa",
      "Mustat ja valkoiset SVG- ja PNG-versiot",
      "CMYK-painoversio PDF-muodossa",
    ],
    caseNote:
      "Sama logo toimii näin verkkosivulla, somessa ja painotuotteissa ilman että laatu riippuu yhden kuvatiedoston koosta.",
    galleryTitle: "Muita logo- ja bränditöitä",
    galleryLead:
      "Muita toteutuksia eri toimialoille, artisteille ja projekteille.",
    processTitle: "Miten logo syntyy?",
    process: [
      {
        title: "1. Lähtökohta ja tavoite",
        text:
          "Käydään läpi nimi, toimiala, käyttökohteet, tyyli ja mahdolliset toiveet. Jos sinulla on vanha logo tai luonnos, sitä voidaan käyttää lähtökohtana.",
      },
      {
        title: "2. Suunta ja luonnokset",
        text:
          "Haetaan tunnukselle toimiva suunta ja muoto. Keskitytään siihen, että idea toimii myös käytännössä eikä vain yksittäisessä esittelykuvassa.",
      },
      {
        title: "3. Palaute ja viimeistely",
        text:
          "Valittua suuntaa tarkennetaan palautteen perusteella. Mittasuhteet, muodot, typografia ja yksityiskohdat viimeistellään yhtenäiseksi kokonaisuudeksi.",
      },
      {
        title: "4. Illustrator ja toimitustiedostot",
        text:
          "Lopullinen logo viimeistellään vektorimuotoon ja toimitetaan projektissa sovituissa käyttöversioissa verkkoa, somea ja tarvittaessa painoa varten.",
      },
    ],
    priceTitle: "Logo hinnoitellaan projektin laajuuden mukaan",
    priceText:
      "Saat hinnan etukäteen ennen työn aloittamista. Hintaan vaikuttavat esimerkiksi lähtötilanne, luonnosten määrä, tarvittavat versiot ja se, tarvitaanko pelkän logon lisäksi muuta visuaalista materiaalia.",
    priceItems: [
      "Selkeä sovittu kokonaisuus ennen työn aloitusta",
      "Palautekierrokset sovitaan projektin mukaan",
      "Lopulliset käyttöversiot sovitussa formaatissa",
      "Mahdollisuus yhdistää projektiin verkkosivut tai muu visuaalinen toteutus",
    ],
    faqTitle: "Usein kysyttyä logosuunnittelusta",
    faq: [
      {
        q: "Mitä tiedostoja saan valmiista logosta?",
        a:
          "Toimitus sovitaan projektikohtaisesti. Tyypillisiä tiedostoja ovat SVG, PDF ja PNG sekä tarvittavat vaaleat ja tummat versiot.",
      },
      {
        q: "Voiko logon saada painokäyttöön?",
        a:
          "Kyllä. Tarvittaessa logo viimeistellään painotuotteisiin sopivaksi ja toimitetaan myös painokelpoisena versiona.",
      },
      {
        q: "Voiko vanhan logon uudistaa?",
        a:
          "Kyllä. Vanhaa logoa voidaan modernisoida säilyttäen tunnistettavia elementtejä tai suunnitella kokonaan uusi suunta tilanteen mukaan.",
      },
      {
        q: "Teetkö logoja vain yrityksille?",
        a:
          "En. Logo voidaan suunnitella yritykselle, artistille, bändille, yhdistykselle, tapahtumalle, henkilöbrändille tai muulle projektille.",
      },
      {
        q: "Onko lopullinen logo vektorimuodossa?",
        a:
          "Kun projekti sitä vaatii, lopullinen logo viimeistellään vektorimuotoon, jolloin se voidaan skaalata pienestä suureksi ilman laadun heikkenemistä.",
      },
      {
        q: "Voiko samaan projektiin yhdistää verkkosivut?",
        a:
          "Kyllä. Logo, verkkosivut ja muu digitaalinen ilme voidaan suunnitella saman kokonaisuuden osina, jolloin visuaalinen linja pysyy yhtenäisenä.",
      },
    ],
    finalTitle: "Tarvitsetko logon, joka toimii oikeasti eri käyttötarkoituksissa?",
    finalLead:
      "Kerro lyhyesti yrityksestäsi, artistiprojektistasi tai brändistäsi ja siitä, mihin logoa tarvitaan. Saat sen perusteella ehdotuksen toteutuksesta.",
  },
  en: {
    badge: "Custom logo design",
    title: "Logo design for a business, artist or brand",
    lead:
      "I design distinctive logos that work across websites, social media and print. The final logo is carefully finished as vector artwork and delivered in the agreed file formats instead of relying on a generic template.",
    primaryCta: "Ask about a logo on WhatsApp",
    secondaryCta: "Get in touch",
    trust: [
      "Custom design",
      "Vector artwork",
      "Web + social + print",
      "Feedback rounds",
    ],
    whoTitle: "Who is logo design for?",
    whoLead:
      "For anyone who needs a distinctive identity that looks credible across different channels and stays usable over time.",
    who: [
      "Businesses and sole traders",
      "Artists and bands",
      "Personal brands",
      "Associations and events",
      "New services and projects",
      "Brands with an outdated logo",
    ],
    deliverablesTitle: "What can a logo project include?",
    deliverables: [
      {
        icon: "palette",
        title: "A visual identity built around your brand",
        text:
          "The logo is designed around the name, industry, audience and desired feel. The goal is a solution that belongs to your brand instead of a generic symbol.",
      },
      {
        icon: "file",
        title: "Vector files and practical versions",
        text:
          "The delivery can include formats such as SVG, PDF and PNG, along with black, white or other practical versions when needed.",
      },
      {
        icon: "mobile",
        title: "Works at small sizes too",
        text:
          "The logo is considered for websites, social profiles and other small placements where the core shape must remain clear and recognisable.",
      },
      {
        icon: "print",
        title: "Ready for print use",
        text:
          "When needed, the artwork can be prepared for print so the same identity works on signs, textiles, stickers and other printed materials.",
      },
    ],
    caseEyebrow: "Featured project",
    caseTitle: "PNP Ranch – a finished logo for web and print",
    caseLead:
      "A horse-themed logo was designed for PNP Ranch based on the client’s wishes. The design was refined through feedback and the final version was finished as vector artwork in Adobe Illustrator.",
    caseBullets: [
      "Horse-themed identity based on the client’s own direction",
      "Final vector artwork completed in Adobe Illustrator",
      "Black and white SVG and PNG versions",
      "CMYK print-ready PDF",
    ],
    caseNote:
      "The same identity can therefore be used on websites, social media and printed materials without depending on the resolution of a single image file.",
    galleryTitle: "Other logo and brand work",
    galleryLead:
      "A selection of other visual identity projects for different industries, artists and projects.",
    processTitle: "How does the logo process work?",
    process: [
      {
        title: "1. Starting point and goal",
        text:
          "We define the name, industry, use cases, preferred style and any existing material. An old logo or sketch can also be used as a starting point.",
      },
      {
        title: "2. Direction and concepts",
        text:
          "A workable visual direction is developed with a focus on an idea that functions in real use, not only in a presentation mock-up.",
      },
      {
        title: "3. Feedback and refinement",
        text:
          "The selected direction is refined based on feedback. Proportions, shapes, typography and details are polished into one coherent identity.",
      },
      {
        title: "4. Illustrator and final files",
        text:
          "The final logo is completed as vector artwork and delivered in the agreed versions for web, social media and print when required.",
      },
    ],
    priceTitle: "Logo projects are priced by scope",
    priceText:
      "You receive a price before the work starts. Pricing depends on the starting point, number of concepts, required versions and whether the project includes additional visual material beyond the logo itself.",
    priceItems: [
      "Clear agreed scope before work begins",
      "Feedback rounds defined for the project",
      "Final practical files in agreed formats",
      "Can be combined with a website or wider visual project",
    ],
    faqTitle: "Frequently asked questions about logo design",
    faq: [
      {
        q: "Which files do I receive with the finished logo?",
        a:
          "The delivery is agreed project by project. Common formats include SVG, PDF and PNG, along with any required light and dark versions.",
      },
      {
        q: "Can the logo be prepared for print?",
        a:
          "Yes. When needed, the logo can be finished and delivered in a print-ready format.",
      },
      {
        q: "Can an old logo be redesigned?",
        a:
          "Yes. An existing logo can be modernised while keeping recognisable elements, or the identity can be redesigned from the ground up.",
      },
      {
        q: "Do you only design logos for businesses?",
        a:
          "No. Logos can be designed for businesses, artists, bands, associations, events, personal brands and other projects.",
      },
      {
        q: "Is the final logo available as vector artwork?",
        a:
          "When the project requires it, the final logo is finished as vector artwork so it can be scaled from small to large without losing quality.",
      },
      {
        q: "Can a website be included in the same project?",
        a:
          "Yes. The logo, website and wider digital identity can be designed as one consistent package.",
      },
    ],
    finalTitle: "Need a logo that works in real-world use?",
    finalLead:
      "Tell me briefly about your business, artist project or brand and where the logo will be used. I can then suggest a suitable approach.",
  },
  es: {
    badge: "Diseño de logotipo a medida",
    title: "Diseño de logotipo para empresa, artista o marca",
    lead:
      "Diseño logotipos reconocibles que funcionan en web, redes sociales e impresión. El logotipo final se termina cuidadosamente como arte vectorial y se entrega en los formatos acordados, sin depender de una plantilla genérica.",
    primaryCta: "Preguntar por WhatsApp",
    secondaryCta: "Contactar",
    trust: [
      "Diseño a medida",
      "Arte vectorial",
      "Web + redes + impresión",
      "Rondas de feedback",
    ],
    whoTitle: "¿Para quién es el diseño de logotipo?",
    whoLead:
      "Para quien necesita una identidad propia, creíble en distintos canales y utilizable durante mucho tiempo.",
    who: [
      "Empresas y autónomos",
      "Artistas y bandas",
      "Marcas personales",
      "Asociaciones y eventos",
      "Nuevos servicios y proyectos",
      "Marcas con un logotipo desactualizado",
    ],
    deliverablesTitle: "¿Qué puede incluir un proyecto de logotipo?",
    deliverables: [
      {
        icon: "palette",
        title: "Identidad diseñada para tu marca",
        text:
          "El logotipo se diseña alrededor del nombre, sector, público y estilo deseado. El objetivo es crear una solución propia en lugar de un símbolo genérico.",
      },
      {
        icon: "file",
        title: "Archivos vectoriales y versiones útiles",
        text:
          "La entrega puede incluir formatos como SVG, PDF y PNG, además de versiones negras, blancas u otras necesarias para el uso real.",
      },
      {
        icon: "mobile",
        title: "Funciona también en tamaños pequeños",
        text:
          "El diseño se comprueba para web, perfiles sociales y otros tamaños pequeños donde la forma principal debe seguir siendo clara.",
      },
      {
        icon: "print",
        title: "Preparado para impresión",
        text:
          "Cuando sea necesario, el logotipo puede prepararse para impresión y utilizarse en rótulos, textiles, pegatinas y otros materiales.",
      },
    ],
    caseEyebrow: "Proyecto destacado",
    caseTitle: "PNP Ranch – logotipo final para web e impresión",
    caseLead:
      "Para PNP Ranch se diseñó un logotipo de temática ecuestre siguiendo las preferencias del cliente. El diseño se refinó con feedback y la versión final se terminó como arte vectorial en Adobe Illustrator.",
    caseBullets: [
      "Identidad ecuestre basada en las preferencias del cliente",
      "Acabado vectorial final en Adobe Illustrator",
      "Versiones SVG y PNG en negro y blanco",
      "PDF CMYK preparado para impresión",
    ],
    caseNote:
      "Así, la misma identidad funciona en web, redes sociales y materiales impresos sin depender de la resolución de una única imagen.",
    galleryTitle: "Otros trabajos de logotipo y marca",
    galleryLead:
      "Una selección de otros proyectos visuales para distintos sectores, artistas y proyectos.",
    processTitle: "¿Cómo se crea el logotipo?",
    process: [
      {
        title: "1. Punto de partida y objetivo",
        text:
          "Definimos nombre, sector, usos, estilo y materiales existentes. También se puede partir de un logotipo antiguo o de un boceto.",
      },
      {
        title: "2. Dirección y conceptos",
        text:
          "Se busca una dirección visual que funcione en uso real y no solo dentro de una presentación.",
      },
      {
        title: "3. Feedback y refinamiento",
        text:
          "La dirección elegida se ajusta según el feedback. Proporciones, formas, tipografía y detalles se refinan hasta formar un conjunto coherente.",
      },
      {
        title: "4. Illustrator y archivos finales",
        text:
          "El logotipo final se termina como arte vectorial y se entrega en las versiones acordadas para web, redes sociales e impresión cuando sea necesario.",
      },
    ],
    priceTitle: "El precio depende del alcance del proyecto",
    priceText:
      "Recibirás un precio antes de empezar. El coste depende del punto de partida, número de conceptos, versiones necesarias y de si el proyecto incluye otros materiales visuales además del logotipo.",
    priceItems: [
      "Alcance claro antes de empezar",
      "Rondas de feedback acordadas",
      "Archivos finales en los formatos definidos",
      "Posibilidad de combinarlo con una web u otro trabajo visual",
    ],
    faqTitle: "Preguntas frecuentes sobre diseño de logotipos",
    faq: [
      {
        q: "¿Qué archivos recibo con el logotipo final?",
        a:
          "La entrega se acuerda para cada proyecto. Los formatos habituales incluyen SVG, PDF y PNG, además de las versiones claras y oscuras necesarias.",
      },
      {
        q: "¿Se puede preparar para impresión?",
        a:
          "Sí. Cuando sea necesario, el logotipo puede terminarse y entregarse en un formato preparado para impresión.",
      },
      {
        q: "¿Se puede renovar un logotipo antiguo?",
        a:
          "Sí. Un logotipo existente puede modernizarse conservando elementos reconocibles o puede rediseñarse completamente.",
      },
      {
        q: "¿Diseñas logotipos solo para empresas?",
        a:
          "No. También diseño para artistas, bandas, asociaciones, eventos, marcas personales y otros proyectos.",
      },
      {
        q: "¿El logotipo final está disponible en formato vectorial?",
        a:
          "Cuando el proyecto lo requiere, el logotipo final se termina como arte vectorial para poder escalarlo sin perder calidad.",
      },
      {
        q: "¿Se puede incluir una web en el mismo proyecto?",
        a:
          "Sí. El logotipo, la web y la identidad digital pueden diseñarse como un único conjunto coherente.",
      },
    ],
    finalTitle: "¿Necesitas un logotipo que funcione en el uso real?",
    finalLead:
      "Cuéntame brevemente sobre tu empresa, proyecto artístico o marca y dónde se utilizará el logotipo. Con esa información puedo proponerte una solución adecuada.",
  },
};

const iconMap = {
  palette: FaPalette,
  file: FaFileAlt,
  mobile: FaMobileAlt,
  print: FaPrint,
};

const gallery = [
  { name: "0MG", image: LogoOMG },
  { name: "Napatoisto", image: LogoNapatoisto },
  { name: "Pro Green", image: LogoProGreen },
  { name: "Ecocreative", image: LogoEcocreative },
  { name: "Buukkeri", image: LogoBuukkeri },
  { name: "Paranoidi", image: LogoParanoidi },
];

function buildWhatsAppUrl(lang, whatsappNumber = WHATSAPP_NUMBER) {
  const message =
    lang === "en"
      ? "Hi Arttu! I am interested in logo design and would like to ask about a project."
      : lang === "es"
      ? "Hola Arttu. Estoy interesado en el diseño de un logotipo y me gustaría consultar un proyecto."
      : "Hei Arttu! Olen kiinnostunut logon suunnittelusta ja haluaisin kysyä projektista.";

  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export default function LogoDesignLandingPage({ lang = "fi", prefix = "" }) {
  const siteContent = useSiteContent();
  const currentLang = lang === "en" || lang === "es" ? lang : "fi";
  const t = deepMerge(
    copy[currentLang],
    siteContent?.pages?.logoDesign?.[currentLang] || {}
  );
  const whatsappUrl = buildWhatsAppUrl(
    currentLang,
    siteContent?.settings?.whatsappNumber || WHATSAPP_NUMBER
  );

  return (
    <>
      <main className="mx-auto w-full max-w-6xl px-2 pb-24 pt-24 sm:px-4 md:px-6 lg:px-12 xl:px-16">
        <section className="relative overflow-hidden rounded-[2rem] border border-black/10 bg-white/70 px-6 py-10 text-center shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:px-10 md:py-14">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-lime-400/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-sky-400/20 blur-3xl" />
          <div className="relative z-10">
            <div className="mb-5 inline-flex rounded-full border border-lime-400/30 bg-lime-400/10 px-4 py-2 text-xs font-bold uppercase tracking-wide text-lime-700 dark:text-lime-300">
              {t.badge}
            </div>
            <h1 className="mx-auto max-w-4xl text-4xl font-bold tracking-tight text-gray-950 dark:text-white md:text-5xl">
              {t.title}
            </h1>
            <p className="mx-auto mt-5 max-w-3xl text-base font-light leading-relaxed text-gray-700 dark:text-gray-200 md:text-lg">
              {t.lead}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02]"
              >
                <FaWhatsapp className="h-5 w-5" />
                {t.primaryCta}
              </a>
              <a
                href={`${prefix || ""}/#contact`}
                className="inline-flex rounded-full border border-black/10 bg-white/80 px-6 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white"
              >
                {t.secondaryCta}
              </a>
            </div>
            <div className="mt-7 flex flex-wrap justify-center gap-2">
              {t.trust.map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-black/10 bg-white/70 px-3 py-1 text-xs font-bold text-gray-700 dark:border-white/10 dark:bg-black/20 dark:text-gray-200"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        </section>

        <section className="mt-14 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5">
            <h2 className="text-2xl font-bold text-gray-950 dark:text-white">
              {t.whoTitle}
            </h2>
            <p className="mt-3 text-gray-700 dark:text-gray-200">{t.whoLead}</p>
            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">
              {t.who.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">
                    <FaCheck className="h-3 w-3" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5">
            <h2 className="text-2xl font-bold text-gray-950 dark:text-white">
              {t.deliverablesTitle}
            </h2>
            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {t.deliverables.map((item) => {
                const Icon = iconMap[item.icon] || FaPalette;

                return (
                  <article
                    key={item.title}
                    className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 dark:border-white/10 dark:bg-black/20"
                  >
                    <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">
                      <Icon className="h-4 w-4" />
                    </div>
                    <h3 className="font-bold text-gray-950 dark:text-white">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                      {item.text}
                    </p>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        <section className="mt-14 overflow-hidden rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="grid items-center gap-8 lg:grid-cols-[0.95fr_1.05fr]">
            <div className="rounded-[1.75rem] border border-black/10 bg-white p-6 shadow-sm sm:p-8">
              <img
                src={PNPLogo}
                alt="PNP Ranch -logo"
                className="mx-auto max-h-[420px] w-full max-w-[560px] object-contain"
              />
            </div>

            <div>
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-lime-700 dark:text-lime-400">
                {t.caseEyebrow}
              </p>
              <h2 className="mt-2 text-3xl font-bold text-gray-950 dark:text-white">
                {t.caseTitle}
              </h2>
              <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">
                {t.caseLead}
              </p>
              <ul className="mt-6 space-y-3">
                {t.caseBullets.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 text-gray-800 dark:text-gray-100"
                  >
                    <FaCheck className="mt-1 h-4 w-4 shrink-0 text-lime-600 dark:text-lime-300" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-6 rounded-2xl border border-black/10 bg-gray-50/80 p-4 text-sm leading-relaxed text-gray-700 dark:border-white/10 dark:bg-black/20 dark:text-gray-200">
                {t.caseNote}
              </p>
            </div>
          </div>
        </section>

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">
              {t.galleryTitle}
            </h2>
            <p className="mt-3 text-gray-700 dark:text-gray-200">
              {t.galleryLead}
            </p>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {gallery.map((item) => (
              <div
                key={item.name}
                className="flex aspect-square items-center justify-center rounded-2xl border border-black/10 bg-white p-4 shadow-sm dark:border-white/10"
                title={item.name}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  loading="lazy"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ))}
          </div>
        </section>

        <section className="mt-14 grid gap-6 lg:grid-cols-[1.15fr_0.85fr]">
          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5 md:p-8">
            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">
              {t.processTitle}
            </h2>
            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {t.process.map((item) => (
                <article
                  key={item.title}
                  className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 dark:border-white/10 dark:bg-black/20"
                >
                  <h3 className="font-bold text-gray-950 dark:text-white">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                    {item.text}
                  </p>
                </article>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-lime-500/30 bg-lime-500/10 p-6 md:p-8">
            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">
              {t.priceTitle}
            </h2>
            <p className="mt-4 leading-relaxed text-gray-800 dark:text-gray-100">
              {t.priceText}
            </p>
            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">
              {t.priceItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <FaCheck className="mt-1 h-4 w-4 shrink-0 text-lime-600 dark:text-lime-300" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">
              {t.faqTitle}
            </h2>
          </div>
          <div className="mx-auto mt-8 grid max-w-4xl gap-4">
            {t.faq.map((item) => (
              <details
                key={item.q}
                className="group rounded-2xl border border-black/10 bg-white/80 p-5 dark:border-white/10 dark:bg-black/20"
              >
                <summary className="cursor-pointer list-none font-bold text-gray-950 dark:text-white">
                  <span className="flex items-center justify-between gap-4">
                    {item.q}
                    <span className="text-xl text-lime-600 transition group-open:rotate-45 dark:text-lime-300">
                      +
                    </span>
                  </span>
                </summary>
                <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                  {item.a}
                </p>
              </details>
            ))}
          </div>
        </section>

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 px-6 py-10 text-center shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:px-10 md:py-12">
          <h2 className="mx-auto max-w-3xl text-3xl font-bold text-gray-950 dark:text-white">
            {t.finalTitle}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-700 dark:text-gray-200">
            {t.finalLead}
          </p>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02]"
            >
              <FaWhatsapp className="h-5 w-5" />
              {t.primaryCta}
            </a>
            <a
              href={`${prefix || ""}/#contact`}
              className="inline-flex rounded-full border border-black/10 bg-white/80 px-6 py-3 font-semibold text-gray-950 transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white"
            >
              {t.secondaryCta}
            </a>
          </div>
        </section>
      </main>

      <Footer lang={currentLang} prefix={prefix} />
    </>
  );
}